import { CHANGE_ICON } from '../types/General/commonActionTypes'

const initialState = {
    isSidebarCollapse: false,
    theme: 'default'
};

const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_ICON:
            {
                return {
                    ...state,
                    isSidebarCollapse: action.payload,
                };
            }
        default:
            return state;
    }
}

export default uiReducer;

